import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../components/navbar';
import axios from 'axios';
import './productview.css';

const ProductView = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedImage, setSelectedImage] = useState(0);
  const [showEnquiryModal, setShowEnquiryModal] = useState(false);
  const [similarProducts, setSimilarProducts] = useState([]);

  const userData = JSON.parse(localStorage.getItem('userData'));
const navigate=useNavigate();
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const productResponse = await axios.get(`${process.env.REACT_APP_API_URL}/ProductView/${id}`);
        const productData = productResponse.data;

        if (productData.status === 'ok') {
          setProduct(productData.data);
        } else {
          setError(productData.message);
        }

        const reviewsResponse = await axios.get(`${process.env.REACT_APP_API_URL}/productReviews/${id}`);
        const reviewsData = reviewsResponse.data;

        if (reviewsData.status === 'ok') {
          setReviews(reviewsData.data);
        }

        // Fetch similar products
        // const similarResponse = await axios.get(`${process.env.REACT_APP_API_URL}/similarProducts/${id}`);
        // if (similarResponse.data.status === 'ok') {
        //   setSimilarProducts(similarResponse.data.data);
        // }
      } catch (error) {
        setError('Unable to load product details. Please try again.');
        console.error('Product fetch error:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id]);

  const handleEnquiry = async (e) => {
    e.preventDefault();

    if (!userData) {
      window.localStorage.setItem('redirectAfterLogin', window.location.pathname);
      window.location.href = '/login';
      return;
    }

    const enquiryData = {
      productname: product.name,
      product_id: id,
      productPrice: product.sellingPrice,
      vendorId: product.vendorId._id,
      UserId: userData._id,
      Username: userData.fname,
      UserNumber: userData.number,
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/sendEnquiry`, enquiryData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = response.data;

      if (data.status === 'ok') {
        setMessage('Enquiry sent successfully!');
        setShowEnquiryModal(false);
        setTimeout(() => setMessage(''), 5000);
      } else {
        setMessage(data.message);
      }
    } catch (error) {
      setMessage('Failed to send enquiry. Please try again.');
    }
  };
const handleViewProfile=(businessSlug)=>{
  navigate(`/${businessSlug}`);

}
  const handleWhatsAppClick = () => {
    const message = `Hi! I'm interested in ${product.name}. Price: ₹${product.sellingPrice}. Please provide more details.`;
    const whatsappUrl = `https://wa.me/${product.vendorId.number}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const calculateDiscount = () => {
    if (product.originalPrice && product.sellingPrice) {
      return Math.round(((product.originalPrice - product.sellingPrice) / product.originalPrice) * 100);
    }
    return 0;
  };

  const getRatingStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`fas fa-star ${i <= rating ? 'filled' : 'empty'}`}
        ></i>
      );
    }
    return stars;
  };

  if (loading) {
    return (
      <div>
        <Navbar />
        <div className="loading-container">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading product details...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Navbar />
        <div className="error-container">
          <div className="error-content">
            <i className="fas fa-exclamation-triangle"></i>
            <h3>Product Not Found</h3>
            <p>{error}</p>
            <button onClick={() => window.history.back()} className="back-btn">
              <i className="fas fa-arrow-left"></i>
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div>
        <Navbar />
        <div className="error-container">
          <div className="error-content">
            <i className="fas fa-search"></i>
            <h3>Product Not Found</h3>
            <p>The product you're looking for doesn't exist.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tradeindia-product-page">
      <Navbar />
      
      {/* Breadcrumb */}
      <div className="breadcrumb-container">
        <div className="container">
          <nav className="breadcrumb">
            <a href="/">Home</a>
            <i className="fas fa-chevron-right"></i>
            <a href="/products">Products</a>
            <i className="fas fa-chevron-right"></i>
            <span>{product.name}</span>
          </nav>
        </div>
      </div>

      {/* Success/Error Messages */}
      {message && (
        <div className="message-container">
          <div className={`alert ${message.includes('success') ? 'alert-success' : 'alert-info'}`}>
            <i className={`fas ${message.includes('success') ? 'fa-check-circle' : 'fa-info-circle'}`}></i>
            {message}
          </div>
        </div>
      )}

      <div className="container product-container">
        <div className="row">
          {/* Product Images and Info */}
          <div className="col-lg-8">
            <div className="product-main-section">
              <div className="row">
                {/* Product Images */}
                <div className="col-md-6">
                  <div className="product-images">
                    <div className="main-image">
                     {product.image?.length > 0 ? (
  <img
    src={`${process.env.REACT_APP_API_URL}/${product.image[selectedImage]?.replace('\\', '/')}`}
    alt={product.name}
    className="img-fluid main-product-image"
  />
) : (
  <div className="no-image-placeholder">
    <i className="fas fa-image"></i>
    <span>No Image Available</span>
  </div>
)}
 
                      
                      {/* Discount Badge */}
                      {calculateDiscount() > 0 && (
                        <div className="discount-badge">
                          {calculateDiscount()}% OFF
                        </div>
                      )}
                    </div>
                    
                    {/* Image Thumbnails (if multiple images) */}
                    <div className="image-thumbnails">
                      {/* Add thumbnail images here when available */}
                    </div>
                  </div>
                </div>

                {/* Product Details */}
                <div className="col-md-6">
                  <div className="product-info">
                    <div className="product-header">
                      <h1 className="product-title-view">{product.name}</h1>
                      <div className="product-meta">
                        <div className="rating-section">
                          <div className="stars">
                            {getRatingStars(4)}
                          </div>
                          <span className="rating-text">4.0 ({reviews.length} reviews)</span>
                        </div>
                        <div className="product-code">
                          Product ID: #{product._id.slice(-8).toUpperCase()}
                        </div>
                      </div>
                    </div>

                    <div className="product-description">
                      <p>{product.smalldescription}</p>
                    </div>

                    {/* Pricing */}
                    <div className="pricing-section">
                      <div className="price-container">
                        <span className="current-price">₹{product.sellingPrice?.toLocaleString('en-IN')}</span>
                        {product.originalPrice && (
                          <span className="original-price">₹{product.originalPrice?.toLocaleString('en-IN')}</span>
                        )}
                      </div>
                      <div className="price-details">
                        <span className="price-label">Per Unit</span>
                        {calculateDiscount() > 0 && (
                          <span className="savings">You save ₹{(product.originalPrice - product.sellingPrice)?.toLocaleString('en-IN')}</span>
                        )}
                      </div>
                    </div>

                    {/* Key Features */}
                    <div className="key-features">
                      <h4>Key Features</h4>
                      <ul>
                        <li><i className="fas fa-check"></i> High Quality Product</li>
                        <li><i className="fas fa-check"></i> Verified Supplier</li>
                        <li><i className="fas fa-check"></i> Fast Delivery</li>
                        <li><i className="fas fa-check"></i> Best Price Guarantee</li>
                      </ul>
                    </div>

                    {/* Action Buttons */}
                    <div className="action-buttons">
                      <button 
                        className="btn-enquiry"
                        onClick={() => setShowEnquiryModal(true)}
                      >
                        <i className="fas fa-envelope"></i>
                        Send Inquiry
                      </button>
                      <button 
                        className="btn-whatsapp"
                        onClick={handleWhatsAppClick}
                      >
                        <i className="fab fa-whatsapp"></i>
                        WhatsApp
                      </button>
                      <button className="btn-call">
                        <i className="fas fa-phone"></i>
                        Call Now
                      </button>
                    </div>

                    {/* Trust Indicators */}
                    <div className="trust-indicators">
                      <div className="trust-item">
                        <i className="fas fa-shield-alt"></i>
                        <span>100% Verified Supplier</span>
                      </div>
                      <div className="trust-item">
                        <i className="fas fa-truck"></i>
                        <span>Fast & Secure Delivery</span>
                      </div>
                      <div className="trust-item">
                        <i className="fas fa-undo"></i>
                        <span>Easy Return Policy</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Seller Details Sidebar */}
          <div className="col-lg-4">
            <div className="seller-card">
              <div className="seller-header">
                <h3>
                  <i className="fas fa-store"></i>
                  Seller Information
                </h3>
                <div className="verified-badge">
                  <i className="fas fa-check-circle"></i>
                  Verified
                </div>
              </div>

              {product.vendorId ? (
                <div className="seller-details">
                  <div className="seller-info-item">
                    <div className="info-label">
                      <i className="fas fa-user"></i>
                      Proprietor
                    </div>
                    <div className="info-value">{product.vendorId.fname}</div>
                  </div>

                  <div className="seller-info-item">
                    <div className="info-label">
                      <i className="fas fa-building"></i>
                      Company
                    </div>
                    <div className="info-value">{product.vendorId.businessName}</div>
                  </div>

                  <div className="seller-info-item">
                    <div className="info-label">
                      <i className="fas fa-envelope"></i>
                      Email
                    </div>
                    <div className="info-value">{product.vendorId.email}</div>
                  </div>

                  <div className="seller-info-item">
                    <div className="info-label">
                      <i className="fas fa-phone"></i>
                      Contact
                    </div>
                    <div className="info-value">{product.vendorId.number}</div>
                  </div>

                  <div className="seller-info-item">
                    <div className="info-label">
                      <i className="fas fa-map-marker-alt"></i>
                      Address
                    </div>
                    <div className="info-value">{product.vendorId.Address}</div>
                  </div>

                  {/* Seller Stats */}
                  <div className="seller-stats">
                    <div className="stat-item">
                      <span className="stat-number">4.5</span>
                      <span className="stat-label">Rating</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-number">150+</span>
                      <span className="stat-label">Products</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-number">{product.vendorId.establishment} Yrs</span>
                      <span className="stat-label">Experience</span>
                    </div>
                  </div>

                  {/* Seller Actions */}
                  <div className="seller-actions">
                    <button className="btn-view-profile" onClick={()=>handleViewProfile(product.vendorId.businessSlug)}>
                      <i className="fas fa-user-circle"></i>
                      View Profile
                    </button>
                    <button className="btn-more-products">
                      <i className="fas fa-th-large"></i>
                      More Products
                    </button>
                  </div>
                </div>
              ) : (
                <p className="no-seller-info">No seller information available.</p>
              )}
            </div>

            {/* Quick Contact Card */}
            <div className="quick-contact-card">
              <h4>
                <i className="fas fa-headset"></i>
                Need Help?
              </h4>
              <p>Get instant support from our team</p>
              <div className="contact-options">
                <button className="contact-option">
                  <i className="fas fa-phone"></i>
                  Call Support
                </button>
                <button className="contact-option">
                  <i className="fas fa-comments"></i>
                  Live Chat
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Product Tabs */}
        <div className="product-tabs-section">
          <div className="tabs-container">
            <div className="tabs-nav">
              <button
                className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
                onClick={() => setActiveTab('overview')}
              >
                <i className="fas fa-info-circle"></i>
                Product Overview
              </button>
              <button
                className={`tab-btn ${activeTab === 'reviews' ? 'active' : ''}`}
                onClick={() => setActiveTab('reviews')}
              >
                <i className="fas fa-star"></i>
                Reviews ({reviews.length})
              </button>
              <button
                className={`tab-btn ${activeTab === 'specifications' ? 'active' : ''}`}
                onClick={() => setActiveTab('specifications')}
              >
                <i className="fas fa-list"></i>
                Specifications
              </button>
            </div>

            <div className="tab-content">
              {activeTab === 'overview' && (
                <div className="overview-content">
                  <h3>Product Overview</h3>
                  <div className="description-content">
                    <p>{product.description || product.smalldescription}</p>
                  </div>
                </div>
              )}

              {activeTab === 'reviews' && (
                <div className="reviews-content">
                  <div className="reviews-header">
                    <h3>Customer Reviews</h3>
                    <div className="reviews-summary">
                      <div className="average-rating">
                        <span className="rating-number">4.0</span>
                        <div className="stars">
                          {getRatingStars(4)}
                        </div>
                        <span className="total-reviews">Based on {reviews.length} reviews</span>
                      </div>
                    </div>
                  </div>

                  <div className="reviews-list">
                    {reviews.length > 0 ? (
                      reviews.map((review) => (
                        <div key={review._id} className="review-item">
                          <div className="review-header">
                            <div className="reviewer-info">
                              <div className="reviewer-avatar">
                                <i className="fas fa-user-circle"></i>
                              </div>
                              <div className="reviewer-details">
                                <h5>{review.Username}</h5>
                                <span className="review-date">
                                  {new Date(review.createdAt).toLocaleDateString()}
                                </span>
                              </div>
                            </div>
                            <div className="review-rating">
                              <div className="stars">
                                {getRatingStars(review.starRate)}
                              </div>
                            </div>
                          </div>
                          
                          <div className="review-content">
                            {review.image && (
                              <div className="review-image">
                                <img
                                  src={`${process.env.REACT_APP_API_URL}/${review.image.replace('\\', '/')}`}
                                  alt="Review"
                                />
                              </div>
                            )}
                            
                            <div className="review-metrics">
                              <div className="metric">
                                <span className="metric-label">Response:</span>
                                <span className={`metric-value ${review.Response ? 'positive' : 'negative'}`}>
                                  {review.Response ? '👍 Good' : '👎 Poor'}
                                </span>
                              </div>
                              <div className="metric">
                                <span className="metric-label">Quality:</span>
                                <span className={`metric-value ${review.Quality ? 'positive' : 'negative'}`}>
                                  {review.Quality ? '👍 Good' : '👎 Poor'}
                                </span>
                              </div>
                              <div className="metric">
                                <span className="metric-label">Delivery:</span>
                                <span className={`metric-value ${review.Delivery ? 'positive' : 'negative'}`}>
                                  {review.Delivery ? '👍 Good' : '👎 Poor'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="no-reviews">
                        <i className="fas fa-star-o"></i>
                        <h4>No Reviews Yet</h4>
                        <p>Be the first to review this product</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {activeTab === 'specifications' && (
                <div className="specifications-content">
                  <h3>Product Specifications</h3>
                  <div className="specs-table">
                    <div className="spec-row">
                      <span className="spec-label">Product Name:</span>
                      <span className="spec-value">{product.name}</span>
                    </div>
                    <div className="spec-row">
                      <span className="spec-label">Price:</span>
                      <span className="spec-value">₹{product.sellingPrice?.toLocaleString('en-IN')}</span>
                    </div>
                    <div className="spec-row">
                      <span className="spec-label">Category:</span>
                      <span className="spec-value">{product.category || 'General'}</span>
                    </div>
                    <div className="spec-row">
                      <span className="spec-label">Availability:</span>
                      <span className="spec-value available">In Stock</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Enquiry Modal */}
      {showEnquiryModal && (
        <div className="modal-overlay" onClick={() => setShowEnquiryModal(false)}>
          <div className="enquiry-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Send Inquiry</h3>
              <button 
                className="close-modal"
                onClick={() => setShowEnquiryModal(false)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="product-summary">
                <img 
                  src={`${process.env.REACT_APP_API_URL}/${product.image?.replace('\\', '/')}`}
                  alt={product.name}
                />
                <div>
                  <h4>{product.name}</h4>
                  <p>₹{product.sellingPrice?.toLocaleString('en-IN')}</p>
                </div>
              </div>
              <form onSubmit={handleEnquiry}>
                <button type="submit" className="submit-enquiry">
                  <i className="fas fa-paper-plane"></i>
                  Send Inquiry
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductView;